module.exports = __webpack_public_path__ + "img/chess-board.12d5c30f.svg";